export default function (context) {
  context.store.dispatch('store__app__footprint__calculator/initFootprintCalculatorStepsFromCookie', context.req)
}
